<p>inventory-serial-movement works!</p>
